import { MenuItem, Select } from "@mui/material";
import MDBox from "components/MDBox";
import UiTypography from "components/base/UiTypography";
import { EstimatingMethod } from "generated/graphql";
import useUpdateProposalEstimatingMethod from "hooks/proposals/useUpdateProposalEstimatingMethod";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";
import { compactSelectSx } from "./worksheetStyles";

type EstimatingMethodControlProps = {
  proposalId: string;
  estimatingMethod: EstimatingMethod;
  canChange?: boolean;
};

export default function EstimatingMethodControl({
  proposalId,
  estimatingMethod,
  canChange,
}: EstimatingMethodControlProps) {
  const [updateProposalEstimatingMethod] = useUpdateProposalEstimatingMethod();

  if (!canChange) {
    return (
      <MDBox display="flex" alignItems="center" gap="4px">
        <UiTypography uiVariant="body-sm" sx={{ color: draftColors.textSecondary }}>
          Estimating:
        </UiTypography>
        <UiTypography uiVariant="body-sm" sx={{ fontWeight: 600 }}>
          {estimatingMethod === EstimatingMethod.WORKSHEET ? "Worksheet" : "Production"}
        </UiTypography>
      </MDBox>
    );
  }

  return (
    <MDBox display="flex" alignItems="center" gap="4px">
      <UiTypography uiVariant="body-sm" sx={{ color: draftColors.textSecondary }}>
        Estimating:
      </UiTypography>
      <Select
        value={estimatingMethod}
        sx={{ ...compactSelectSx, minWidth: 130 }}
        onChange={(event) =>
          updateProposalEstimatingMethod({
            variables: {
              id: proposalId,
              estimatingMethod: event.target.value as EstimatingMethod,
            },
          })
        }
      >
        <MenuItem value={EstimatingMethod.PRODUCTION} sx={{ fontSize: "11px" }}>
          Production
        </MenuItem>
        <MenuItem value={EstimatingMethod.WORKSHEET} sx={{ fontSize: "11px" }}>
          Worksheet
        </MenuItem>
      </Select>
    </MDBox>
  );
}
